// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OPgM","rootMobile":"styles_rootMobile__16eIt"};